// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== LOGIN PAGE - Premium Side-by-side layout ===== */
/* The Google Fonts @import that used to sit here has been removed. Inter is
   self-hosted — index.html preloads one variable woff2 covering 400–800 and
   declares the @font-face itself. The import re-fetched the same family from
   fonts.googleapis.com: a render-blocking third-party request (DNS + TLS +
   two round trips before any text could paint) for a font already in memory,
   and a CSP exception nobody needed. Worse, a CSS @import must resolve before
   the rest of the sheet applies, so it blocked the login page specifically. */

.login-page {
  display: flex;
  min-height: 100vh;
  font-family:var(--font-display);
  background: linear-gradient(135deg, var(--brand-50) 0%, var(--brand-50) 50%, var(--n-50) 100%);
  overflow-x: hidden;              /* guard: never scroll sideways */
}
/* width:100% + padding controls (inputs/buttons) must include padding in width,
   otherwise they overflow the viewport on mobile. Scoped to the login page. */
.login-page *,
.login-page *::before,
.login-page *::after { box-sizing: border-box; }

/* ===== LEFT PANEL - Animated Dark branding =====
   Same gradient, same angle and same stops as .lp-hero on the landing page.
   It used to be its own four-stop ramp at 145deg, which meant clicking
   "Sign in" swapped one blue for a visibly different one — the moment that
   made the two screens read as two products. */
/* Half the window, not a fixed 480px column. At 480px the brand panel read as
   a sidebar next to the form; at half it reads as the other half of the same
   page. Capped at 720px so it does not become a blue field on a wide monitor. */
.login-left {
  position: relative;
  flex: 0 0 50%;
  max-width: 720px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(120deg, var(--brand-800) 0%, var(--brand-600) 52%, var(--brand-500) 100%);
  overflow: hidden;
}

/* Shrink-wraps the logo box and nothing else, so it IS the logo's footprint —
   which is what the helm below centres on. inline-block rather than a width:
   the box changes size at two breakpoints, and this follows it without either
   of them having to know about the wheel. \`.login-left-content\` is
   text-align:center, which is what centres this. */
.login-mark {
  position: relative;
  display: inline-block;
  line-height: 0;              /* no descender gap under the box */
  margin: 0 0 32px;
}
.login-mark .login-logo-box { margin: 0; }

/* The helm from the landing hero, turning around the company mark.
   Centred on .login-mark, so the logo sits at the hub of the wheel rather than
   the wheel sitting in the middle of the panel with the logo somewhere above
   it.

   EXPLICIT NEGATIVE MARGINS, NOT \`inset:0 + margin:auto\`. The auto-margin
   trick centres an element on its container only while it FITS. This wheel is
   400px inside a ~110px box, and the two axes then disagree:
     • horizontally, CSS 2.1 §10.3.8 says that if equal auto margins would come
       out negative, set margin-left to 0 and solve for margin-right instead —
       so the wheel is pinned to the box's left edge and hangs off to the right
     • vertically, §10.6.5 carries no such exception, so the margins do go
       negative and it centres correctly
   That asymmetry is exactly what it looked like: right vertically, shoved
   right horizontally. top/left:50% with a −half-size margin has no such
   clause and lands the hub on the logo on both axes. It also leaves
   \`transform\` free, which the spin needs — translate-based centring would be
   wiped by the animation's first frame.

   Faint on purpose. The artwork is greyscale, so opacity alone decides how
   much gradient shows through: at this value it is the blue lightening very
   slightly where the spokes pass, not a picture laid on the panel competing
   with the wordmark in front of it. */
.login-left-helm {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 400px;
  height: 400px;
  margin: -200px 0 0 -200px;   /* centred on the mark (half the size above) */
  /* Clearly visible lotus, but it sits BEHIND the white logo card (z-index below
     the card + brand text) so it never paints over the white — only the petals
     around the card show. */
  opacity: 0.16;
  z-index: 0;
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  /* The Ponsuvai lotus stays still (the helm it replaced used to turn). */
}

.login-left-glow {
  position: absolute;
  top: 10%;
  left: 25%;
  width: 350px;
  height: 350px;
  background: radial-gradient(circle, rgba(59, 130, 246, 0.28) 0%, rgba(37, 99, 235, 0.2) 40%, transparent 72%);
  border-radius: 50%;
  pointer-events: none;
  animation: loginGlowPulse 6s var(--ease-in-out) infinite;
}
.login-left-glow::after {
  content: '';
  position: absolute;
  bottom: -100px;
  right: -80px;
  width: 250px;
  height: 250px;
  background: radial-gradient(circle, rgba(191, 219, 254, 0.24) 0%, transparent 70%);
  border-radius: 50%;
  animation: loginGlowPulse 8s var(--ease-in-out) infinite reverse;
}

@keyframes loginGlowPulse {
  0%, 100% { transform: scale(1); opacity: 0.7; }
  50% { transform: scale(1.15); opacity: 1; }
}

/* Was a 28px dot field; now the same 56px blueprint grid the landing hero
   uses, masked the same way so it fades before it reaches any edge. Same
   texture on both sides of the sign-in click. */
.login-left-dots {
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(255,255,255,.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255,255,255,.03) 1px, transparent 1px);
  background-size: 56px 56px;
  mask-image: radial-gradient(120% 90% at 50% 45%, #000 30%, transparent 78%);
  pointer-events: none;
}

.login-left::before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 1px;
  height: 100%;
  background: linear-gradient(to bottom, transparent 0%, rgba(96, 165, 250, 0.5) 30%, rgba(96, 165, 250, 0.5) 70%, transparent 100%);
}

.login-left-content {
  position: relative;
  z-index: 2;
  text-align: center;
  padding: 42px 24px;
  animation: loginFadeUp var(--dur-slower) var(--ease-out);
}

@keyframes loginFadeUp {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

.login-logo-box {
  position: relative;          /* lift the white card above the lotus watermark */
  z-index: 1;
  width: 110px;
  height: 110px;
  background: var(--n-0);
  border-radius: var(--radius-2xl);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 32px;
  box-shadow: 0 12px 40px rgba(0,0,0,0.3), 0 0 0 1px rgba(255,255,255,0.06), 0 0 60px rgba(99,102,241,0.08);
  overflow: hidden;
  transition: transform var(--dur-slow) ease;
}
.login-logo-box:hover { transform: scale(1.04); }

.login-logo-img {
  width: 78px;
  height: 78px;
  object-fit: contain;
}

.login-logo-fallback {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Set like the landing hero's h1 — display face, negative tracking. The old
   +3px letter-spacing was the other half of why the two screens looked
   unrelated: the same word, spaced apart on one page and tight on the next. */
.login-brand {
  position: relative;          /* keep the wordmark above the lotus watermark */
  z-index: 1;
  font-family: var(--font-display);
  font-size: 34px;
  font-weight: 800;
  color: var(--on-dark);
  letter-spacing: -0.02em;
  margin: 0 0 12px;
  text-shadow: 0 2px 18px rgba(0,0,0,0.4);
}

.login-brand-sub {
  position: relative;
  z-index: 1;
  font-size: 20px;
  color: var(--on-dark);
  margin: 0 0 10px;
  font-weight: 700;
  letter-spacing: 0.5px;
  line-height: var(--lh-tight);
  text-shadow: 0 2px 10px rgba(0,0,0,0.4);
}

.login-brand-co {
  position: relative;
  z-index: 1;
  font-size: 16px;
  color: var(--on-dark-accent);
  margin: 0;
  font-weight: 600;
  letter-spacing: 0.3px;
  text-shadow: 0 1px 8px rgba(0,0,0,0.35);
}

/* ===== RIGHT PANEL ===== */
.login-right {
  flex: 1 1;
  /* The bubbles are absolutely positioned against this, and clipped by it —
     without \`relative\` they would escape to the viewport and drift across the
     blue panel too. */
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  background: linear-gradient(180deg, var(--n-0) 0%, var(--n-50) 100%);
}

.login-form-wrap {
  width: 100%;
  max-width: 400px;
  /* Above the bubbles, and a positioning context so it wins regardless of
     source order. */
  position: relative;
  z-index: 1;
  animation: loginFormSlide var(--dur-slower) var(--ease-out) var(--dur-base) both;
}

/* ── drifting bubbles ─────────────────────────────────────────────────────
   Six brand-tinted circles behind the form. Two rules make them read as air
   rather than as decoration someone added:

   • no two share a size, a path or a duration. The durations are deliberately
     coprime-ish (23/31/19/37/27/43s) so the set never re-syncs into a visible
     pattern — with round numbers they would all line up every minute or so.
   • negative animation-delay. That starts each one part-way through its own
     loop, so on page load they are already scattered mid-drift instead of all
     setting off together from their starting positions.

   Very low alpha on purpose: this is a white form people are about to type a
   password into, and contrast against the inputs matters more than the effect. */
.login-bubbles {
  position: absolute;
  inset: 0;
  overflow: hidden;
  pointer-events: none;
  z-index: 0;
}
/* Form panel: --brand-500 on near-white paper. */
.login-bub {
  position: absolute;
  border-radius: 50%;
  background: radial-gradient(circle at 32% 30%,
    rgba(22, 104, 179, 0.13) 0%,
    rgba(22, 104, 179, 0.05) 55%,
    rgba(22, 104, 179, 0) 72%);
  will-change: transform;
}
.login-bub-1 { width: 210px; height: 210px; top:  8%; left:  6%; animation: loginBubA 23s var(--ease-in-out)  -4s infinite; }
.login-bub-2 { width:  96px; height:  96px; top: 62%; left: 12%; animation: loginBubB 31s var(--ease-in-out) -11s infinite; }
.login-bub-3 { width: 148px; height: 148px; top: 24%; left: 74%; animation: loginBubC 19s var(--ease-in-out)  -7s infinite; }
.login-bub-4 { width:  62px; height:  62px; top: 80%; left: 68%; animation: loginBubA 37s var(--ease-in-out) -19s infinite; }
.login-bub-5 { width: 260px; height: 260px; top: 52%; left: 44%; animation: loginBubB 27s var(--ease-in-out)  -3s infinite; }
.login-bub-6 { width: 118px; height: 118px; top:  4%; left: 52%; animation: loginBubC 43s var(--ease-in-out) -25s infinite; }

/* Nothing here for .login-left: the bubbles are the form panel's alone. The
   blue side already carries the pulsing glow, the blueprint grid and the
   turning helm, and a fourth moving layer behind the wordmark was one too
   many. */

/* Three paths, not one — reusing a single keyframe at different speeds still
   reads as one motion. Each drifts and breathes slightly. */
@keyframes loginBubA {
  0%, 100% { transform: translate(0, 0) scale(1); }
  33%      { transform: translate(38px, -30px) scale(1.09); }
  66%      { transform: translate(-22px, 26px) scale(0.95); }
}
@keyframes loginBubB {
  0%, 100% { transform: translate(0, 0) scale(1); }
  40%      { transform: translate(-34px, -22px) scale(0.93); }
  75%      { transform: translate(26px, 34px) scale(1.07); }
}
@keyframes loginBubC {
  0%, 100% { transform: translate(0, 0) scale(1); }
  50%      { transform: translate(30px, 40px) scale(1.12); }
}

@keyframes loginFormSlide {
  from { opacity: 0; transform: translateX(20px); }
  to { opacity: 1; transform: translateX(0); }
}

.login-title {
  font-family: var(--font-display);
  font-size: 32px;
  font-weight: 800;
  color: var(--brand-800);
  margin: 0 0 8px;
  letter-spacing: -0.028em;
}

.login-subtitle {
  font-size: 14px;
  color: var(--n-600);
  margin: 0 0 36px;
  line-height: var(--lh-relaxed);
}

.login-error {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: var(--clr-danger-bg);
  border: 1px solid var(--clr-danger-border);
  border-radius: var(--radius-xl);
  color: var(--clr-danger-dark);
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 20px;
  animation: loginShake var(--dur-slower) ease;
}

@keyframes loginShake {
  0%, 100% { transform: translateX(0); }
  20% { transform: translateX(-6px); }
  40% { transform: translateX(6px); }
  60% { transform: translateX(-4px); }
  80% { transform: translateX(4px); }
}

.login-field { margin-bottom: 24px; }

.login-label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  color: var(--n-700);
  letter-spacing: 0.8px;
  margin-bottom: 8px;
  text-transform: uppercase;
}

.login-input-wrap {
  position: relative;
  display: flex;
  align-items: center;
}

.login-input-icon {
  position: absolute;
  left: 14px;
  pointer-events: none;
  z-index: 1;
  transition: stroke var(--dur-base);
}
.login-input-wrap:focus-within .login-input-icon { stroke: var(--clr-accent) !important; }

.login-input {
  width: 100%;
  padding: 14px 14px 14px 44px;
  font-size: 14px;
  font-family: inherit;
  border: 1.5px solid var(--n-300);
  border-radius: var(--radius-xl);
  background: var(--n-100);
  color: var(--brand-900);
  transition: all var(--dur-slow) ease;
  outline: none;
}

.login-input:focus {
  border-color: var(--clr-accent);
  background: var(--n-0);
  box-shadow: 0 0 0 3.5px rgba(37, 99, 235, 0.2);
}

.login-input::placeholder { color: var(--clr-text-muted); font-weight: 400; }

.login-pw-toggle {
  position: absolute;
  right: 12px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  opacity: 0.5;
  transition: opacity var(--dur-base);
}
.login-pw-toggle:hover { opacity: 1; }

.login-btn {
  width: 100%;
  padding: 16px;
  font-size: 16px;
  font-weight: 700;
  font-family: inherit;
  color: var(--n-0);
  background: linear-gradient(135deg, var(--brand-700) 0%, var(--clr-accent) 52%, var(--clr-accent) 100%);
  border: none;
  border-radius: var(--radius-xl);
  cursor: pointer;
  transition: all var(--dur-slow) ease;
  margin-top: 8px;
  letter-spacing: 0.3px;
  box-shadow: 0 4px 18px rgba(30, 64, 175, 0.35);
  position: relative;
  overflow: hidden;
}

.login-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 200%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.1), transparent);
  transition: left var(--dur-slower) ease;
}
.login-btn:hover::before { left: 100%; }

.login-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(30, 64, 175, 0.42);
  background: linear-gradient(135deg, var(--clr-accent-hover) 0%, var(--clr-accent) 45%, var(--brand-400) 100%);
}

.login-btn:active:not(:disabled) { transform: translateY(0); box-shadow: 0 4px 14px rgba(30, 64, 175, 0.3); }
.login-btn:disabled { opacity: 0.7; cursor: not-allowed; }

/* ── "OR CONTINUE WITH" divider + Sign in with Google ── */
.login-or {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 20px 0 16px;
}
.login-or-rule {
  flex: 1 1;
  height: 1px;
  background: var(--clr-border, var(--n-200));
}
.login-or-text {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  color: var(--clr-text-muted, var(--n-400));
}

/* Google's brand guidelines want the mark on a plain light surface, so this one
   button keeps a white face in dark mode instead of taking the card token. */
.login-google-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 11px 16px;
  border-radius: var(--radius-lg, 8px);
  border: 1px solid var(--clr-border, var(--n-200));
  background: #fff;
  color: #1f2937;
  font-size: 14px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: opacity var(--dur-base) ease, filter var(--dur-base) ease, box-shadow var(--dur-base) ease;
}
.login-google-btn:hover:not(:disabled) { box-shadow: 0 2px 10px rgba(15, 32, 68, 0.12); }
.login-google-btn:disabled { cursor: not-allowed; }

/* No role picked yet: greyed out, because the backend needs the role to mint
   the token and the popup would only fail. */
.login-google-btn.is-locked { opacity: 0.5; filter: grayscale(0.5); }

.login-google-hint {
  font-size: 12px;
  color: var(--clr-text-muted, var(--n-400));
  text-align: center;
  margin-top: 8px;
}

@media (prefers-reduced-motion: reduce) {
  .login-google-btn { transition: none; }
}

.login-spinner {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2.5px solid rgba(255,255,255,0.3);
  border-top-color: var(--n-0);
  border-radius: 50%;
  animation: loginSpin var(--dur-slower) linear infinite;
}
@keyframes loginSpin { to { transform: rotate(360deg); } }

.login-footer {
  text-align: center;
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.login-footer span { font-size: 11px; color: var(--clr-text-muted); }
.login-footer span:first-child { font-weight: 700; color: var(--n-600); }

@media (max-width: 1024px) {
  .login-page {
    flex-direction: column;
    min-height: 100vh;
    overflow-y: auto;
  }
  .login-left {
    flex: 0 0 auto;
    /* The 720px cap above keeps the panel from becoming a blue field on a wide
       monitor. Once the layout stacks it is a full-width band instead, so the
       cap has to come off or it sits short and left-aligned. */
    max-width: none;
    padding: 28px 24px 24px;
  }
  .login-left-content {
    padding: 0;
  }
  /* Gone below 1024px. Once the layout stacks, the left panel is a shallow
     band and the wheel is centred on a logo sitting near its top edge — over
     half of it would fall outside and clip to an arc. Shrinking it enough to
     fit would leave something too small to read as a wheel at all, so it goes
     entirely, the same call the landing hero makes on a phone. */
  .login-left-helm { display: none; }
  .login-logo-box {
    width: 76px;
    height: 76px;
    border-radius: var(--radius-2xl);
  }
  /* The gap under the mark lives on the wrapper now — the box's own margin is
     zeroed so the wheel can centre on its footprint alone. */
  .login-mark { margin-bottom: 16px; }
  .login-logo-img { width: 52px; height: 52px; }
  .login-brand { font-size: 20px; margin-bottom: 6px; }
  .login-brand-sub { font-size: 14px; margin-bottom: 4px; }
  .login-brand-co { font-size: 13px; }
  .login-right {
    flex: 1 1;
    padding: 28px 20px 32px;
    align-items: flex-start;
  }
  .login-form-wrap { max-width: 100%; }
}

@media (max-width: 480px) {
  .login-page {
    min-height: 100vh;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  .login-left {
    padding: 22px 20px 18px;
  }
  .login-logo-box {
    width: 68px;
    height: 68px;
    border-radius: var(--radius-2xl);
  }
  .login-mark { margin-bottom: 12px; }
  .login-logo-img { width: 46px; height: 46px; }
  .login-brand { font-size: 20px; letter-spacing: 2px; margin-bottom: 4px; }
  .login-brand-sub { font-size: 13px; }
  .login-brand-co { font-size: 12px; }
  .login-right { padding: 24px 16px 28px; }
  .login-title { font-size: 20px; margin-bottom: 6px; }
  .login-subtitle { font-size: 13px; margin-bottom: 24px; }
  .login-form-wrap { max-width: 100%; }
  .login-input { font-size: 14px; padding: 12px 12px 12px 40px; }
  .login-btn { padding: 14px; font-size: 14px; }
  .login-footer { margin-top: 24px; }
}

/* ── Login-As role dropdown ───────────────────────────────────── */
.login-required-star {
  color: var(--danger-500);
  margin-left: 2px;
  font-weight: 700;
}

.login-role-select {
  position: relative;
}

.login-role-trigger {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 12px 14px;
  background: var(--n-100);
  border: 1.5px solid var(--n-300);
  border-radius: var(--radius-xl);
  cursor: pointer;
  font-family: inherit;
  font-size: 14px;
  color: var(--brand-900);
  transition: all var(--dur-base) ease;
}
.login-role-trigger:hover { border-color: var(--clr-accent); }
.login-role-select.is-open .login-role-trigger {
  border-color: var(--clr-accent);
  background: var(--n-0);
  box-shadow: 0 0 0 3.5px rgba(37, 99, 235, 0.2);
}

.login-role-trigger-left {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  flex: 1 1;
}

.login-role-placeholder {
  color: var(--n-400);
  font-weight: 400;
}

.login-role-text {
  font-weight: 700;
  color: var(--brand-900);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.login-role-chev {
  flex: 0 0 auto;
  transition: transform var(--dur-base) ease;
}
.login-role-chev.rot { transform: rotate(180deg); }

.login-role-list {
  list-style: none;
  margin: 6px 0 0;
  padding: 6px;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: var(--n-0);
  border: 1.5px solid var(--n-200);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-lg);
  z-index: 50;
  max-height: 320px;
  overflow-y: auto;
}

.login-role-item {
  padding: 12px 14px;
  border-radius: var(--radius-lg);
  cursor: pointer;
  transition: background var(--dur-base) ease;
  font-size: 14px;
  font-weight: 600;
  color: var(--brand-900);
}
.login-role-item + .login-role-item { margin-top: 2px; }
.login-role-item:hover { background: var(--n-100); }
.login-role-item.is-selected { background: var(--brand-50); color: var(--clr-accent-hover); }

/* ── Forgot-password sub-views ───────────────────────────────────────── */
/* Two ends of one row: the way out on the left, the way back in on the right.
   space-between, not flex-end — and the JSX renders an empty <span> when there
   is no landing page to return to, so "Forgot password?" stays pinned right
   instead of sliding across when its partner is absent. */
.login-fp-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: -8px 0 14px;
}

/* Matched to "Forgot password?" at the other end of the row — same size, same
   weight, same accent blue. They are peers: two secondary ways out of the
   form, so neither should look more clickable than the other. The arrow slides
   on hover, which is the conventional signal for "this leaves the form"
   rather than "this changes it". */
.login-explore {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0;
  background: none;
  border: 0;
  cursor: pointer;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  color: var(--clr-accent);
  transition: color var(--dur-base) var(--ease-out);
}
.login-explore svg { transition: transform var(--dur-base) var(--ease-out); }
.login-explore:hover { text-decoration: underline; }
.login-explore:hover svg { transform: translateX(3px); }
@media (prefers-reduced-motion: reduce) {
  .login-explore svg,
  .login-explore:hover svg { transition: none; transform: none; }
}
.login-fp-link {
  background: none;
  border: none;
  padding: 0;
  font-size: 13px;
  font-weight: 600;
  color: var(--clr-accent);
  cursor: pointer;
  font-family: inherit;
}
.login-fp-link:hover { text-decoration: underline; }
.login-fp-link:disabled { color: var(--n-400); cursor: not-allowed; text-decoration: none; }

.login-back {
  background: none;
  border: none;
  padding: 0 0 16px;
  font-size: 12px;
  font-weight: 600;
  color: var(--n-500);
  cursor: pointer;
  font-family: inherit;
}
.login-back:hover { color: var(--n-900); }

.login-fp-title {
  margin: 0 0 6px;
  font-size: 20px;
  font-weight: 700;
  color: var(--brand-900);
  font-family: inherit;
}
.login-fp-sub {
  margin: 0 0 20px;
  font-size: 13px;
  color: var(--n-500);
  line-height: var(--lh-relaxed);
}

.login-info {
  margin: 0 0 14px;
  padding: 10px 12px;
  background: var(--success-50);
  color: var(--success-700);
  border: 1px solid var(--success-200);
  border-radius: var(--radius-lg);
  font-size: 12px;
}

.login-otp-input {
  text-align: center;
  font-size: 20px !important;
  letter-spacing: 6px;
  font-weight: 700;
  font-family: ui-monospace, "SF Mono", Menlo, monospace;
  padding-left: 12px !important;
}

.login-fp-note {
  margin: 14px 0 0;
  font-size: 12px;
  color: var(--n-400);
  text-align: center;
}

.login-fp-resend {
  margin-top: 14px;
  font-size: 13px;
  color: var(--n-600);
  text-align: center;
}

.login-fp-success {
  text-align: center;
  padding: 8px 0;
}
.login-fp-success-icon {
  width: 80px;
  height: 80px;
  margin: 8px auto 18px;
  border-radius: 50%;
  background: var(--success-100);
  display: flex;
  align-items: center;
  justify-content: center;
}
.login-fp-success .login-fp-title { margin-bottom: 8px; }
.login-fp-success .login-btn { margin-top: 8px; }
/* ── keyboard ─────────────────────────────────────────────────────────────
   The login page had no focus styling either. It is a form — the one screen
   where people most reasonably expect to work without a mouse, and where
   losing your place means typing a password into the wrong box. */
.login-page a:focus-visible,
.login-page button:focus-visible,
.login-page input:focus-visible,
.login-page [role="option"]:focus-visible {
  outline: 2px solid var(--clr-accent);
  outline-offset: 2px;
  border-radius: var(--radius-md);
}
/* The inputs already grow an accent border on :focus; doubling it with an
   outline just makes the field look broken. The border IS the indicator. */
.login-input:focus-visible { outline: none; }
.login-left button:focus-visible { outline-color: var(--clr-white); }

/* ── reduced motion ───────────────────────────────────────────────────────
   Four decorative animations run here, two of them forever: the pulsing glow
   and the turning helm. Those stop. The entrance ones resolve to their final
   frame rather than being removed, so nothing ends up invisible.
   The button spinner is deliberately left alone — it is not decoration, it is
   the only signal that a sign-in is in flight. */
@media (prefers-reduced-motion: reduce) {
  .login-left-glow,
  .login-left-helm,
  /* The bubbles are the most persistent motion on the page — six things
     drifting continuously behind a form. They stop where they are; they still
     read as soft shapes on the panel, just still ones. */
  .login-bub { animation: none; }
  .login-left-content,
  .login-form-wrap { animation: none; opacity: 1; transform: none; }
  .login-error { animation: none; }
  .login-logo-box,
  .login-btn:hover:not(:disabled) { transition: none; transform: none; }
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/login.css"],"names":[],"mappings":"AAAA,yDAAyD;AACzD;;;;;;8EAM8E;;AAE9E;EACE,aAAa;EACb,iBAAiB;EACjB,+BAA+B;EAC/B,8FAA8F;EAC9F,kBAAkB,eAAe,iCAAiC;AACpE;AACA;8EAC8E;AAC9E;;uBAEuB,sBAAsB,EAAE;;AAE/C;;;;+CAI+C;AAC/C;;gFAEgF;AAChF;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qGAAqG;EACrG,gBAAgB;AAClB;;AAEA;;;;mDAImD;AACnD;EACE,kBAAkB;EAClB,qBAAqB;EACrB,cAAc,eAAe,mCAAmC;EAChE,gBAAgB;AAClB;AACA,8BAA8B,SAAS,EAAE;;AAEzC;;;;;;;;;;;;;;;;;;;;;;sCAsBsC;AACtC;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,aAAa;EACb,yBAAyB,IAAI,8CAA8C;EAC3E;;4BAE0B;EAC1B,aAAa;EACb,UAAU;EACV,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;EACjB,wEAAwE;AAC1E;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,aAAa;EACb,6GAA6G;EAC7G,kBAAkB;EAClB,oBAAoB;EACpB,wDAAwD;AAC1D;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kFAAkF;EAClF,kBAAkB;EAClB,gEAAgE;AAClE;;AAEA;EACE,WAAW,mBAAmB,EAAE,YAAY,EAAE;EAC9C,MAAM,sBAAsB,EAAE,UAAU,EAAE;AAC5C;;AAEA;;gDAEgD;AAChD;EACE,kBAAkB;EAClB,QAAQ;EACR;;sEAEoE;EACpE,0BAA0B;EAE1B,2EAA2E;EAC3E,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,kIAAkI;AACpI;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,kBAAkB,WAAW,kDAAkD;EAC/E,UAAU;EACV,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yGAAyG;EACzG,gBAAgB;EAChB,0CAA0C;AAC5C;AACA,wBAAwB,sBAAsB,EAAE;;AAEhD;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;8EAE8E;AAC9E;EACE,kBAAkB,WAAW,gDAAgD;EAC7E,UAAU;EACV,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,4BAA4B;EAC5B,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,4BAA4B;EAC5B,SAAS;EACT,gBAAgB;EAChB,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA,4BAA4B;AAC5B;EACE,SAAO;EACP;;sBAEoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,oEAAoE;AACtE;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB;oBACkB;EAClB,kBAAkB;EAClB,UAAU;EACV,gFAAgF;AAClF;;AAEA;;;;;;;;;;;;iFAYiF;AACjF;EACE,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,UAAU;AACZ;AACA,iDAAiD;AACjD;EACE,kBAAkB;EAClB,kBAAkB;EAClB;;;8BAG4B;EAC5B,sBAAsB;AACxB;AACA,eAAe,YAAY,EAAE,aAAa,EAAE,QAAQ,EAAE,SAAS,EAAE,yDAAyD,EAAE;AAC5H,eAAe,YAAY,EAAE,aAAa,EAAE,QAAQ,EAAE,SAAS,EAAE,yDAAyD,EAAE;AAC5H,eAAe,YAAY,EAAE,aAAa,EAAE,QAAQ,EAAE,SAAS,EAAE,yDAAyD,EAAE;AAC5H,eAAe,YAAY,EAAE,aAAa,EAAE,QAAQ,EAAE,SAAS,EAAE,yDAAyD,EAAE;AAC5H,eAAe,YAAY,EAAE,aAAa,EAAE,QAAQ,EAAE,SAAS,EAAE,yDAAyD,EAAE;AAC5H,eAAe,YAAY,EAAE,aAAa,EAAE,QAAQ,EAAE,SAAS,EAAE,yDAAyD,EAAE;;AAE5H;;;UAGU;;AAEV;4DAC4D;AAC5D;EACE,WAAW,mCAAmC,EAAE;EAChD,WAAW,6CAA6C,EAAE;EAC1D,WAAW,6CAA6C,EAAE;AAC5D;AACA;EACE,WAAW,mCAAmC,EAAE;EAChD,WAAW,8CAA8C,EAAE;EAC3D,WAAW,4CAA4C,EAAE;AAC3D;AACA;EACE,WAAW,mCAAmC,EAAE;EAChD,WAAW,4CAA4C,EAAE;AAC3D;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gCAAgC;EAChC,0CAA0C;EAC1C,+BAA+B;EAC/B,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;EACnC,MAAM,0BAA0B,EAAE;EAClC,MAAM,2BAA2B,EAAE;EACnC,MAAM,0BAA0B,EAAE;AACpC;;AAEA,eAAe,mBAAmB,EAAE;;AAEpC;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,UAAU;EACV,kCAAkC;AACpC;AACA,mDAAmD,oCAAoC,EAAE;;AAEzF;EACE,WAAW;EACX,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;EACpB,gCAAgC;EAChC,+BAA+B;EAC/B,wBAAwB;EACxB,uBAAuB;EACvB,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA,4BAA4B,4BAA4B,EAAE,gBAAgB,EAAE;;AAE5E;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mCAAmC;AACrC;AACA,yBAAyB,UAAU,EAAE;;AAErC;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,uGAAuG;EACvG,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,oCAAoC;EACpC,eAAe;EACf,qBAAqB;EACrB,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mFAAmF;EACnF,uCAAuC;AACzC;AACA,2BAA2B,UAAU,EAAE;;AAEvC;EACE,2BAA2B;EAC3B,8CAA8C;EAC9C,6GAA6G;AAC/G;;AAEA,mCAAmC,wBAAwB,EAAE,6CAA6C,EAAE;AAC5G,sBAAsB,YAAY,EAAE,mBAAmB,EAAE;;AAEzD,2DAA2D;AAC3D;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,SAAO;EACP,WAAW;EACX,2CAA2C;AAC7C;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;6EAC6E;AAC7E;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,oCAAoC;EACpC,iDAAiD;EACjD,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,sGAAsG;AACxG;AACA,yCAAyC,6CAA6C,EAAE;AACxF,6BAA6B,mBAAmB,EAAE;;AAElD;6CAC6C;AAC7C,8BAA8B,YAAY,EAAE,sBAAsB,EAAE;;AAEpE;EACE,eAAe;EACf,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,oBAAoB,gBAAgB,EAAE;AACxC;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,4BAA4B;EAC5B,kBAAkB;EAClB,sDAAsD;AACxD;AACA,uBAAuB,KAAK,yBAAyB,EAAE,EAAE;;AAEzD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA,qBAAqB,eAAe,EAAE,4BAA4B,EAAE;AACpE,iCAAiC,gBAAgB,EAAE,mBAAmB,EAAE;;AAExE;EACE;IACE,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,cAAc;IACd;;+DAE2D;IAC3D,eAAe;IACf,uBAAuB;EACzB;EACA;IACE,UAAU;EACZ;EACA;;;;iEAI+D;EAC/D,mBAAmB,aAAa,EAAE;EAClC;IACE,WAAW;IACX,YAAY;IACZ,gCAAgC;EAClC;EACA;6DAC2D;EAC3D,cAAc,mBAAmB,EAAE;EACnC,kBAAkB,WAAW,EAAE,YAAY,EAAE;EAC7C,eAAe,eAAe,EAAE,kBAAkB,EAAE;EACpD,mBAAmB,eAAe,EAAE,kBAAkB,EAAE;EACxD,kBAAkB,eAAe,EAAE;EACnC;IACE,SAAO;IACP,uBAAuB;IACvB,uBAAuB;EACzB;EACA,mBAAmB,eAAe,EAAE;AACtC;;AAEA;EACE;IACE,iBAAiB;IACjB,gBAAgB;IAChB,iCAAiC;EACnC;EACA;IACE,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,YAAY;IACZ,gCAAgC;EAClC;EACA,cAAc,mBAAmB,EAAE;EACnC,kBAAkB,WAAW,EAAE,YAAY,EAAE;EAC7C,eAAe,eAAe,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;EACzE,mBAAmB,eAAe,EAAE;EACpC,kBAAkB,eAAe,EAAE;EACnC,eAAe,uBAAuB,EAAE;EACxC,eAAe,eAAe,EAAE,kBAAkB,EAAE;EACpD,kBAAkB,eAAe,EAAE,mBAAmB,EAAE;EACxD,mBAAmB,eAAe,EAAE;EACpC,eAAe,eAAe,EAAE,4BAA4B,EAAE;EAC9D,aAAa,aAAa,EAAE,eAAe,EAAE;EAC7C,gBAAgB,gBAAgB,EAAE;AACpC;;AAEA,oEAAoE;AACpE;EACE,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,wBAAwB;EACxB,gCAAgC;EAChC,+BAA+B;EAC/B,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,uBAAuB;EACvB,oCAAoC;AACtC;AACA,4BAA4B,+BAA+B,EAAE;AAC7D;EACE,+BAA+B;EAC/B,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;AACA,uBAAuB,yBAAyB,EAAE;;AAElD;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,sBAAsB;EACtB,gCAAgC;EAChC,+BAA+B;EAC/B,4BAA4B;EAC5B,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,2CAA2C;EAC3C,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;AACA,sCAAsC,eAAe,EAAE;AACvD,yBAAyB,wBAAwB,EAAE;AACnD,+BAA+B,2BAA2B,EAAE,8BAA8B,EAAE;;AAE5F,2EAA2E;AAC3E;;;0DAG0D;AAC1D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;;;;mCAImC;AACnC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,iDAAiD;AACnD;AACA,qBAAqB,qDAAqD,EAAE;AAC5E,uBAAuB,0BAA0B,EAAE;AACnD,2BAA2B,0BAA0B,EAAE;AACvD;EACE;6BAC2B,gBAAgB,EAAE,eAAe,EAAE;AAChE;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,oBAAoB;AACtB;AACA,uBAAuB,0BAA0B,EAAE;AACnD,0BAA0B,mBAAmB,EAAE,mBAAmB,EAAE,qBAAqB,EAAE;;AAE3F;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;AACA,oBAAoB,mBAAmB,EAAE;;AAEzC;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,oCAAoC;EACpC,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,sDAAsD;EACtD,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA,oCAAoC,kBAAkB,EAAE;AACxD,+BAA+B,eAAe,EAAE;AAChD;;;kEAGkE;AAClE;;;;EAIE,oCAAoC;EACpC,mBAAmB;EACnB,+BAA+B;AACjC;AACA;2EAC2E;AAC3E,6BAA6B,aAAa,EAAE;AAC5C,mCAAmC,+BAA+B,EAAE;;AAEpE;;;;;iDAKiD;AACjD;EACE;;;;;eAKa,eAAe,EAAE;EAC9B;qBACmB,eAAe,EAAE,UAAU,EAAE,eAAe,EAAE;EACjE,eAAe,eAAe,EAAE;EAChC;oCACkC,gBAAgB,EAAE,eAAe,EAAE;AACvE","sourcesContent":["/* ===== LOGIN PAGE - Premium Side-by-side layout ===== */\n/* The Google Fonts @import that used to sit here has been removed. Inter is\n   self-hosted — index.html preloads one variable woff2 covering 400–800 and\n   declares the @font-face itself. The import re-fetched the same family from\n   fonts.googleapis.com: a render-blocking third-party request (DNS + TLS +\n   two round trips before any text could paint) for a font already in memory,\n   and a CSP exception nobody needed. Worse, a CSS @import must resolve before\n   the rest of the sheet applies, so it blocked the login page specifically. */\n\n.login-page {\n  display: flex;\n  min-height: 100vh;\n  font-family:var(--font-display);\n  background: linear-gradient(135deg, var(--brand-50) 0%, var(--brand-50) 50%, var(--n-50) 100%);\n  overflow-x: hidden;              /* guard: never scroll sideways */\n}\n/* width:100% + padding controls (inputs/buttons) must include padding in width,\n   otherwise they overflow the viewport on mobile. Scoped to the login page. */\n.login-page *,\n.login-page *::before,\n.login-page *::after { box-sizing: border-box; }\n\n/* ===== LEFT PANEL - Animated Dark branding =====\n   Same gradient, same angle and same stops as .lp-hero on the landing page.\n   It used to be its own four-stop ramp at 145deg, which meant clicking\n   \"Sign in\" swapped one blue for a visibly different one — the moment that\n   made the two screens read as two products. */\n/* Half the window, not a fixed 480px column. At 480px the brand panel read as\n   a sidebar next to the form; at half it reads as the other half of the same\n   page. Capped at 720px so it does not become a blue field on a wide monitor. */\n.login-left {\n  position: relative;\n  flex: 0 0 50%;\n  max-width: 720px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(120deg, var(--brand-800) 0%, var(--brand-600) 52%, var(--brand-500) 100%);\n  overflow: hidden;\n}\n\n/* Shrink-wraps the logo box and nothing else, so it IS the logo's footprint —\n   which is what the helm below centres on. inline-block rather than a width:\n   the box changes size at two breakpoints, and this follows it without either\n   of them having to know about the wheel. `.login-left-content` is\n   text-align:center, which is what centres this. */\n.login-mark {\n  position: relative;\n  display: inline-block;\n  line-height: 0;              /* no descender gap under the box */\n  margin: 0 0 32px;\n}\n.login-mark .login-logo-box { margin: 0; }\n\n/* The helm from the landing hero, turning around the company mark.\n   Centred on .login-mark, so the logo sits at the hub of the wheel rather than\n   the wheel sitting in the middle of the panel with the logo somewhere above\n   it.\n\n   EXPLICIT NEGATIVE MARGINS, NOT `inset:0 + margin:auto`. The auto-margin\n   trick centres an element on its container only while it FITS. This wheel is\n   400px inside a ~110px box, and the two axes then disagree:\n     • horizontally, CSS 2.1 §10.3.8 says that if equal auto margins would come\n       out negative, set margin-left to 0 and solve for margin-right instead —\n       so the wheel is pinned to the box's left edge and hangs off to the right\n     • vertically, §10.6.5 carries no such exception, so the margins do go\n       negative and it centres correctly\n   That asymmetry is exactly what it looked like: right vertically, shoved\n   right horizontally. top/left:50% with a −half-size margin has no such\n   clause and lands the hub on the logo on both axes. It also leaves\n   `transform` free, which the spin needs — translate-based centring would be\n   wiped by the animation's first frame.\n\n   Faint on purpose. The artwork is greyscale, so opacity alone decides how\n   much gradient shows through: at this value it is the blue lightening very\n   slightly where the spokes pass, not a picture laid on the panel competing\n   with the wordmark in front of it. */\n.login-left-helm {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 400px;\n  height: 400px;\n  margin: -200px 0 0 -200px;   /* centred on the mark (half the size above) */\n  /* Clearly visible lotus, but it sits BEHIND the white logo card (z-index below\n     the card + brand text) so it never paints over the white — only the petals\n     around the card show. */\n  opacity: 0.16;\n  z-index: 0;\n  pointer-events: none;\n  user-select: none;\n  /* The Ponsuvai lotus stays still (the helm it replaced used to turn). */\n}\n\n.login-left-glow {\n  position: absolute;\n  top: 10%;\n  left: 25%;\n  width: 350px;\n  height: 350px;\n  background: radial-gradient(circle, rgba(59, 130, 246, 0.28) 0%, rgba(37, 99, 235, 0.2) 40%, transparent 72%);\n  border-radius: 50%;\n  pointer-events: none;\n  animation: loginGlowPulse 6s var(--ease-in-out) infinite;\n}\n.login-left-glow::after {\n  content: '';\n  position: absolute;\n  bottom: -100px;\n  right: -80px;\n  width: 250px;\n  height: 250px;\n  background: radial-gradient(circle, rgba(191, 219, 254, 0.24) 0%, transparent 70%);\n  border-radius: 50%;\n  animation: loginGlowPulse 8s var(--ease-in-out) infinite reverse;\n}\n\n@keyframes loginGlowPulse {\n  0%, 100% { transform: scale(1); opacity: 0.7; }\n  50% { transform: scale(1.15); opacity: 1; }\n}\n\n/* Was a 28px dot field; now the same 56px blueprint grid the landing hero\n   uses, masked the same way so it fades before it reaches any edge. Same\n   texture on both sides of the sign-in click. */\n.login-left-dots {\n  position: absolute;\n  inset: 0;\n  background-image:\n    linear-gradient(rgba(255,255,255,.03) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(255,255,255,.03) 1px, transparent 1px);\n  background-size: 56px 56px;\n  -webkit-mask-image: radial-gradient(120% 90% at 50% 45%, #000 30%, transparent 78%);\n  mask-image: radial-gradient(120% 90% at 50% 45%, #000 30%, transparent 78%);\n  pointer-events: none;\n}\n\n.login-left::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 1px;\n  height: 100%;\n  background: linear-gradient(to bottom, transparent 0%, rgba(96, 165, 250, 0.5) 30%, rgba(96, 165, 250, 0.5) 70%, transparent 100%);\n}\n\n.login-left-content {\n  position: relative;\n  z-index: 2;\n  text-align: center;\n  padding: 42px 24px;\n  animation: loginFadeUp var(--dur-slower) var(--ease-out);\n}\n\n@keyframes loginFadeUp {\n  from { opacity: 0; transform: translateY(20px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.login-logo-box {\n  position: relative;          /* lift the white card above the lotus watermark */\n  z-index: 1;\n  width: 110px;\n  height: 110px;\n  background: var(--n-0);\n  border-radius: var(--radius-2xl);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 32px;\n  box-shadow: 0 12px 40px rgba(0,0,0,0.3), 0 0 0 1px rgba(255,255,255,0.06), 0 0 60px rgba(99,102,241,0.08);\n  overflow: hidden;\n  transition: transform var(--dur-slow) ease;\n}\n.login-logo-box:hover { transform: scale(1.04); }\n\n.login-logo-img {\n  width: 78px;\n  height: 78px;\n  object-fit: contain;\n}\n\n.login-logo-fallback {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Set like the landing hero's h1 — display face, negative tracking. The old\n   +3px letter-spacing was the other half of why the two screens looked\n   unrelated: the same word, spaced apart on one page and tight on the next. */\n.login-brand {\n  position: relative;          /* keep the wordmark above the lotus watermark */\n  z-index: 1;\n  font-family: var(--font-display);\n  font-size: 34px;\n  font-weight: 800;\n  color: var(--on-dark);\n  letter-spacing: -0.02em;\n  margin: 0 0 12px;\n  text-shadow: 0 2px 18px rgba(0,0,0,0.4);\n}\n\n.login-brand-sub {\n  position: relative;\n  z-index: 1;\n  font-size: 20px;\n  color: var(--on-dark);\n  margin: 0 0 10px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  line-height: var(--lh-tight);\n  text-shadow: 0 2px 10px rgba(0,0,0,0.4);\n}\n\n.login-brand-co {\n  position: relative;\n  z-index: 1;\n  font-size: 16px;\n  color: var(--on-dark-accent);\n  margin: 0;\n  font-weight: 600;\n  letter-spacing: 0.3px;\n  text-shadow: 0 1px 8px rgba(0,0,0,0.35);\n}\n\n/* ===== RIGHT PANEL ===== */\n.login-right {\n  flex: 1;\n  /* The bubbles are absolutely positioned against this, and clipped by it —\n     without `relative` they would escape to the viewport and drift across the\n     blue panel too. */\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n  background: linear-gradient(180deg, var(--n-0) 0%, var(--n-50) 100%);\n}\n\n.login-form-wrap {\n  width: 100%;\n  max-width: 400px;\n  /* Above the bubbles, and a positioning context so it wins regardless of\n     source order. */\n  position: relative;\n  z-index: 1;\n  animation: loginFormSlide var(--dur-slower) var(--ease-out) var(--dur-base) both;\n}\n\n/* ── drifting bubbles ─────────────────────────────────────────────────────\n   Six brand-tinted circles behind the form. Two rules make them read as air\n   rather than as decoration someone added:\n\n   • no two share a size, a path or a duration. The durations are deliberately\n     coprime-ish (23/31/19/37/27/43s) so the set never re-syncs into a visible\n     pattern — with round numbers they would all line up every minute or so.\n   • negative animation-delay. That starts each one part-way through its own\n     loop, so on page load they are already scattered mid-drift instead of all\n     setting off together from their starting positions.\n\n   Very low alpha on purpose: this is a white form people are about to type a\n   password into, and contrast against the inputs matters more than the effect. */\n.login-bubbles {\n  position: absolute;\n  inset: 0;\n  overflow: hidden;\n  pointer-events: none;\n  z-index: 0;\n}\n/* Form panel: --brand-500 on near-white paper. */\n.login-bub {\n  position: absolute;\n  border-radius: 50%;\n  background: radial-gradient(circle at 32% 30%,\n    rgba(22, 104, 179, 0.13) 0%,\n    rgba(22, 104, 179, 0.05) 55%,\n    rgba(22, 104, 179, 0) 72%);\n  will-change: transform;\n}\n.login-bub-1 { width: 210px; height: 210px; top:  8%; left:  6%; animation: loginBubA 23s var(--ease-in-out)  -4s infinite; }\n.login-bub-2 { width:  96px; height:  96px; top: 62%; left: 12%; animation: loginBubB 31s var(--ease-in-out) -11s infinite; }\n.login-bub-3 { width: 148px; height: 148px; top: 24%; left: 74%; animation: loginBubC 19s var(--ease-in-out)  -7s infinite; }\n.login-bub-4 { width:  62px; height:  62px; top: 80%; left: 68%; animation: loginBubA 37s var(--ease-in-out) -19s infinite; }\n.login-bub-5 { width: 260px; height: 260px; top: 52%; left: 44%; animation: loginBubB 27s var(--ease-in-out)  -3s infinite; }\n.login-bub-6 { width: 118px; height: 118px; top:  4%; left: 52%; animation: loginBubC 43s var(--ease-in-out) -25s infinite; }\n\n/* Nothing here for .login-left: the bubbles are the form panel's alone. The\n   blue side already carries the pulsing glow, the blueprint grid and the\n   turning helm, and a fourth moving layer behind the wordmark was one too\n   many. */\n\n/* Three paths, not one — reusing a single keyframe at different speeds still\n   reads as one motion. Each drifts and breathes slightly. */\n@keyframes loginBubA {\n  0%, 100% { transform: translate(0, 0) scale(1); }\n  33%      { transform: translate(38px, -30px) scale(1.09); }\n  66%      { transform: translate(-22px, 26px) scale(0.95); }\n}\n@keyframes loginBubB {\n  0%, 100% { transform: translate(0, 0) scale(1); }\n  40%      { transform: translate(-34px, -22px) scale(0.93); }\n  75%      { transform: translate(26px, 34px) scale(1.07); }\n}\n@keyframes loginBubC {\n  0%, 100% { transform: translate(0, 0) scale(1); }\n  50%      { transform: translate(30px, 40px) scale(1.12); }\n}\n\n@keyframes loginFormSlide {\n  from { opacity: 0; transform: translateX(20px); }\n  to { opacity: 1; transform: translateX(0); }\n}\n\n.login-title {\n  font-family: var(--font-display);\n  font-size: 32px;\n  font-weight: 800;\n  color: var(--brand-800);\n  margin: 0 0 8px;\n  letter-spacing: -0.028em;\n}\n\n.login-subtitle {\n  font-size: 14px;\n  color: var(--n-600);\n  margin: 0 0 36px;\n  line-height: var(--lh-relaxed);\n}\n\n.login-error {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 16px;\n  background: var(--clr-danger-bg);\n  border: 1px solid var(--clr-danger-border);\n  border-radius: var(--radius-xl);\n  color: var(--clr-danger-dark);\n  font-size: 13px;\n  font-weight: 500;\n  margin-bottom: 20px;\n  animation: loginShake var(--dur-slower) ease;\n}\n\n@keyframes loginShake {\n  0%, 100% { transform: translateX(0); }\n  20% { transform: translateX(-6px); }\n  40% { transform: translateX(6px); }\n  60% { transform: translateX(-4px); }\n  80% { transform: translateX(4px); }\n}\n\n.login-field { margin-bottom: 24px; }\n\n.login-label {\n  display: block;\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--n-700);\n  letter-spacing: 0.8px;\n  margin-bottom: 8px;\n  text-transform: uppercase;\n}\n\n.login-input-wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.login-input-icon {\n  position: absolute;\n  left: 14px;\n  pointer-events: none;\n  z-index: 1;\n  transition: stroke var(--dur-base);\n}\n.login-input-wrap:focus-within .login-input-icon { stroke: var(--clr-accent) !important; }\n\n.login-input {\n  width: 100%;\n  padding: 14px 14px 14px 44px;\n  font-size: 14px;\n  font-family: inherit;\n  border: 1.5px solid var(--n-300);\n  border-radius: var(--radius-xl);\n  background: var(--n-100);\n  color: var(--brand-900);\n  transition: all var(--dur-slow) ease;\n  outline: none;\n}\n\n.login-input:focus {\n  border-color: var(--clr-accent);\n  background: var(--n-0);\n  box-shadow: 0 0 0 3.5px rgba(37, 99, 235, 0.2);\n}\n\n.login-input::placeholder { color: var(--clr-text-muted); font-weight: 400; }\n\n.login-pw-toggle {\n  position: absolute;\n  right: 12px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  opacity: 0.5;\n  transition: opacity var(--dur-base);\n}\n.login-pw-toggle:hover { opacity: 1; }\n\n.login-btn {\n  width: 100%;\n  padding: 16px;\n  font-size: 16px;\n  font-weight: 700;\n  font-family: inherit;\n  color: var(--n-0);\n  background: linear-gradient(135deg, var(--brand-700) 0%, var(--clr-accent) 52%, var(--clr-accent) 100%);\n  border: none;\n  border-radius: var(--radius-xl);\n  cursor: pointer;\n  transition: all var(--dur-slow) ease;\n  margin-top: 8px;\n  letter-spacing: 0.3px;\n  box-shadow: 0 4px 18px rgba(30, 64, 175, 0.35);\n  position: relative;\n  overflow: hidden;\n}\n\n.login-btn::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 200%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.1), transparent);\n  transition: left var(--dur-slower) ease;\n}\n.login-btn:hover::before { left: 100%; }\n\n.login-btn:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(30, 64, 175, 0.42);\n  background: linear-gradient(135deg, var(--clr-accent-hover) 0%, var(--clr-accent) 45%, var(--brand-400) 100%);\n}\n\n.login-btn:active:not(:disabled) { transform: translateY(0); box-shadow: 0 4px 14px rgba(30, 64, 175, 0.3); }\n.login-btn:disabled { opacity: 0.7; cursor: not-allowed; }\n\n/* ── \"OR CONTINUE WITH\" divider + Sign in with Google ── */\n.login-or {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin: 20px 0 16px;\n}\n.login-or-rule {\n  flex: 1;\n  height: 1px;\n  background: var(--clr-border, var(--n-200));\n}\n.login-or-text {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  color: var(--clr-text-muted, var(--n-400));\n}\n\n/* Google's brand guidelines want the mark on a plain light surface, so this one\n   button keeps a white face in dark mode instead of taking the card token. */\n.login-google-btn {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  padding: 11px 16px;\n  border-radius: var(--radius-lg, 8px);\n  border: 1px solid var(--clr-border, var(--n-200));\n  background: #fff;\n  color: #1f2937;\n  font-size: 14px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  transition: opacity var(--dur-base) ease, filter var(--dur-base) ease, box-shadow var(--dur-base) ease;\n}\n.login-google-btn:hover:not(:disabled) { box-shadow: 0 2px 10px rgba(15, 32, 68, 0.12); }\n.login-google-btn:disabled { cursor: not-allowed; }\n\n/* No role picked yet: greyed out, because the backend needs the role to mint\n   the token and the popup would only fail. */\n.login-google-btn.is-locked { opacity: 0.5; filter: grayscale(0.5); }\n\n.login-google-hint {\n  font-size: 12px;\n  color: var(--clr-text-muted, var(--n-400));\n  text-align: center;\n  margin-top: 8px;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .login-google-btn { transition: none; }\n}\n\n.login-spinner {\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  border: 2.5px solid rgba(255,255,255,0.3);\n  border-top-color: var(--n-0);\n  border-radius: 50%;\n  animation: loginSpin var(--dur-slower) linear infinite;\n}\n@keyframes loginSpin { to { transform: rotate(360deg); } }\n\n.login-footer {\n  text-align: center;\n  margin-top: 40px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.login-footer span { font-size: 11px; color: var(--clr-text-muted); }\n.login-footer span:first-child { font-weight: 700; color: var(--n-600); }\n\n@media (max-width: 1024px) {\n  .login-page {\n    flex-direction: column;\n    min-height: 100vh;\n    overflow-y: auto;\n  }\n  .login-left {\n    flex: 0 0 auto;\n    /* The 720px cap above keeps the panel from becoming a blue field on a wide\n       monitor. Once the layout stacks it is a full-width band instead, so the\n       cap has to come off or it sits short and left-aligned. */\n    max-width: none;\n    padding: 28px 24px 24px;\n  }\n  .login-left-content {\n    padding: 0;\n  }\n  /* Gone below 1024px. Once the layout stacks, the left panel is a shallow\n     band and the wheel is centred on a logo sitting near its top edge — over\n     half of it would fall outside and clip to an arc. Shrinking it enough to\n     fit would leave something too small to read as a wheel at all, so it goes\n     entirely, the same call the landing hero makes on a phone. */\n  .login-left-helm { display: none; }\n  .login-logo-box {\n    width: 76px;\n    height: 76px;\n    border-radius: var(--radius-2xl);\n  }\n  /* The gap under the mark lives on the wrapper now — the box's own margin is\n     zeroed so the wheel can centre on its footprint alone. */\n  .login-mark { margin-bottom: 16px; }\n  .login-logo-img { width: 52px; height: 52px; }\n  .login-brand { font-size: 20px; margin-bottom: 6px; }\n  .login-brand-sub { font-size: 14px; margin-bottom: 4px; }\n  .login-brand-co { font-size: 13px; }\n  .login-right {\n    flex: 1;\n    padding: 28px 20px 32px;\n    align-items: flex-start;\n  }\n  .login-form-wrap { max-width: 100%; }\n}\n\n@media (max-width: 480px) {\n  .login-page {\n    min-height: 100vh;\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n  .login-left {\n    padding: 22px 20px 18px;\n  }\n  .login-logo-box {\n    width: 68px;\n    height: 68px;\n    border-radius: var(--radius-2xl);\n  }\n  .login-mark { margin-bottom: 12px; }\n  .login-logo-img { width: 46px; height: 46px; }\n  .login-brand { font-size: 20px; letter-spacing: 2px; margin-bottom: 4px; }\n  .login-brand-sub { font-size: 13px; }\n  .login-brand-co { font-size: 12px; }\n  .login-right { padding: 24px 16px 28px; }\n  .login-title { font-size: 20px; margin-bottom: 6px; }\n  .login-subtitle { font-size: 13px; margin-bottom: 24px; }\n  .login-form-wrap { max-width: 100%; }\n  .login-input { font-size: 14px; padding: 12px 12px 12px 40px; }\n  .login-btn { padding: 14px; font-size: 14px; }\n  .login-footer { margin-top: 24px; }\n}\n\n/* ── Login-As role dropdown ───────────────────────────────────── */\n.login-required-star {\n  color: var(--danger-500);\n  margin-left: 2px;\n  font-weight: 700;\n}\n\n.login-role-select {\n  position: relative;\n}\n\n.login-role-trigger {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 12px 14px;\n  background: var(--n-100);\n  border: 1.5px solid var(--n-300);\n  border-radius: var(--radius-xl);\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 14px;\n  color: var(--brand-900);\n  transition: all var(--dur-base) ease;\n}\n.login-role-trigger:hover { border-color: var(--clr-accent); }\n.login-role-select.is-open .login-role-trigger {\n  border-color: var(--clr-accent);\n  background: var(--n-0);\n  box-shadow: 0 0 0 3.5px rgba(37, 99, 235, 0.2);\n}\n\n.login-role-trigger-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n  flex: 1;\n}\n\n.login-role-placeholder {\n  color: var(--n-400);\n  font-weight: 400;\n}\n\n.login-role-text {\n  font-weight: 700;\n  color: var(--brand-900);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.login-role-chev {\n  flex: 0 0 auto;\n  transition: transform var(--dur-base) ease;\n}\n.login-role-chev.rot { transform: rotate(180deg); }\n\n.login-role-list {\n  list-style: none;\n  margin: 6px 0 0;\n  padding: 6px;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: var(--n-0);\n  border: 1.5px solid var(--n-200);\n  border-radius: var(--radius-xl);\n  box-shadow: var(--shadow-lg);\n  z-index: 50;\n  max-height: 320px;\n  overflow-y: auto;\n}\n\n.login-role-item {\n  padding: 12px 14px;\n  border-radius: var(--radius-lg);\n  cursor: pointer;\n  transition: background var(--dur-base) ease;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--brand-900);\n}\n.login-role-item + .login-role-item { margin-top: 2px; }\n.login-role-item:hover { background: var(--n-100); }\n.login-role-item.is-selected { background: var(--brand-50); color: var(--clr-accent-hover); }\n\n/* ── Forgot-password sub-views ───────────────────────────────────────── */\n/* Two ends of one row: the way out on the left, the way back in on the right.\n   space-between, not flex-end — and the JSX renders an empty <span> when there\n   is no landing page to return to, so \"Forgot password?\" stays pinned right\n   instead of sliding across when its partner is absent. */\n.login-fp-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin: -8px 0 14px;\n}\n\n/* Matched to \"Forgot password?\" at the other end of the row — same size, same\n   weight, same accent blue. They are peers: two secondary ways out of the\n   form, so neither should look more clickable than the other. The arrow slides\n   on hover, which is the conventional signal for \"this leaves the form\"\n   rather than \"this changes it\". */\n.login-explore {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 0;\n  background: none;\n  border: 0;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--clr-accent);\n  transition: color var(--dur-base) var(--ease-out);\n}\n.login-explore svg { transition: transform var(--dur-base) var(--ease-out); }\n.login-explore:hover { text-decoration: underline; }\n.login-explore:hover svg { transform: translateX(3px); }\n@media (prefers-reduced-motion: reduce) {\n  .login-explore svg,\n  .login-explore:hover svg { transition: none; transform: none; }\n}\n.login-fp-link {\n  background: none;\n  border: none;\n  padding: 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--clr-accent);\n  cursor: pointer;\n  font-family: inherit;\n}\n.login-fp-link:hover { text-decoration: underline; }\n.login-fp-link:disabled { color: var(--n-400); cursor: not-allowed; text-decoration: none; }\n\n.login-back {\n  background: none;\n  border: none;\n  padding: 0 0 16px;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--n-500);\n  cursor: pointer;\n  font-family: inherit;\n}\n.login-back:hover { color: var(--n-900); }\n\n.login-fp-title {\n  margin: 0 0 6px;\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--brand-900);\n  font-family: inherit;\n}\n.login-fp-sub {\n  margin: 0 0 20px;\n  font-size: 13px;\n  color: var(--n-500);\n  line-height: var(--lh-relaxed);\n}\n\n.login-info {\n  margin: 0 0 14px;\n  padding: 10px 12px;\n  background: var(--success-50);\n  color: var(--success-700);\n  border: 1px solid var(--success-200);\n  border-radius: var(--radius-lg);\n  font-size: 12px;\n}\n\n.login-otp-input {\n  text-align: center;\n  font-size: 20px !important;\n  letter-spacing: 6px;\n  font-weight: 700;\n  font-family: ui-monospace, \"SF Mono\", Menlo, monospace;\n  padding-left: 12px !important;\n}\n\n.login-fp-note {\n  margin: 14px 0 0;\n  font-size: 12px;\n  color: var(--n-400);\n  text-align: center;\n}\n\n.login-fp-resend {\n  margin-top: 14px;\n  font-size: 13px;\n  color: var(--n-600);\n  text-align: center;\n}\n\n.login-fp-success {\n  text-align: center;\n  padding: 8px 0;\n}\n.login-fp-success-icon {\n  width: 80px;\n  height: 80px;\n  margin: 8px auto 18px;\n  border-radius: 50%;\n  background: var(--success-100);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.login-fp-success .login-fp-title { margin-bottom: 8px; }\n.login-fp-success .login-btn { margin-top: 8px; }\n/* ── keyboard ─────────────────────────────────────────────────────────────\n   The login page had no focus styling either. It is a form — the one screen\n   where people most reasonably expect to work without a mouse, and where\n   losing your place means typing a password into the wrong box. */\n.login-page a:focus-visible,\n.login-page button:focus-visible,\n.login-page input:focus-visible,\n.login-page [role=\"option\"]:focus-visible {\n  outline: 2px solid var(--clr-accent);\n  outline-offset: 2px;\n  border-radius: var(--radius-md);\n}\n/* The inputs already grow an accent border on :focus; doubling it with an\n   outline just makes the field look broken. The border IS the indicator. */\n.login-input:focus-visible { outline: none; }\n.login-left button:focus-visible { outline-color: var(--clr-white); }\n\n/* ── reduced motion ───────────────────────────────────────────────────────\n   Four decorative animations run here, two of them forever: the pulsing glow\n   and the turning helm. Those stop. The entrance ones resolve to their final\n   frame rather than being removed, so nothing ends up invisible.\n   The button spinner is deliberately left alone — it is not decoration, it is\n   the only signal that a sign-in is in flight. */\n@media (prefers-reduced-motion: reduce) {\n  .login-left-glow,\n  .login-left-helm,\n  /* The bubbles are the most persistent motion on the page — six things\n     drifting continuously behind a form. They stop where they are; they still\n     read as soft shapes on the panel, just still ones. */\n  .login-bub { animation: none; }\n  .login-left-content,\n  .login-form-wrap { animation: none; opacity: 1; transform: none; }\n  .login-error { animation: none; }\n  .login-logo-box,\n  .login-btn:hover:not(:disabled) { transition: none; transform: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
